import Highcharts from "highcharts";
import { CurrencyFormatter } from "../chartHelper";
import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const PROJECT_MONITORED_CHART_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      ...chartConfig.chart,
      zoomType: "xy",
      renderTo: "bar-chart",
      className: "chart-background",
      spacingBottom: 50,
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.FIRST_PAGE.FIRST._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      text: "PMG MONITORED PROJECTS"
    },
    subtitle: {
      ...chartConfig.subtitle,
      text: "Count & Investment of Projects monitored by PMG",
      verticalAlign: "bottom",
      y: 25
    },
    xAxis: [
      {
        categories: [],
        className: "bar-label",
        labels: {
          autoRotation: [-90],
          formatter: function() {
            return this.value;
          }
        }
      }
    ],
    yAxis: [
      {
        // Primary yAxis
        labels: {
          format: `{value}`
        },
        title: {
          text: "Number of Project(s)"
        },
        min: 0,
        max: 0,
        className: "bar-label"
      },
      {
        // Secondary yAxis
        title: {
          text: "Total Investments (Lakh Cr.)"
        },
        labels: {
          formatter: function() {
            return CurrencyFormatter(this.value / 100000).replace(/,/g, ".");
          }
        },
        min: 0,
        max: 0,
        opposite: true,
        className: "bar-label"
      }
    ],
    tooltip: {
      shared: true,
      // pointFormat: `{series.name}: <b>{point.y}</b><br/>`
      formatter: function() {
        const { points } = this;
        return `
                <b>Projects: ${points[0].y}</b><br />
                <b>Cost: ${CurrencyFormatter(points[1].y / 100000)} Lakh Cr</b>
              `;
      }
    },
    legend: {
      verticalAlign: "bottom",
      layout: "horizontal",
      align: "center",
      symbolRadius: 0,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || // theme
        "rgba(255,255,255,0.25)"
    },
    series: [
      {
        name: "PMG Monitored Project(s)",
        type: "spline",
        yAxis: 0,
        zIndex: 1,
        data: [],
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          style: {
            textOutline: "none"
          }
        }
      },
      {
        name: "Total Investments (Lakh Cr.)",
        type: "column",
        data: [],
        yAxis: 1,
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          position: "center",
          verticalAlign: "middle",
          inside: true,
          rotation: -90,
          formatter: function() {
            return CurrencyFormatter(this.y)
              .substr(0, 5)
              .replace(/,/g, ".");
          },
          style: {
            textOutline: "none",
            color: "#fff"
          }
        },
        color: "#fb9f47"
      }
    ],
    plotOptions: {
      series: {
        animation: false,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    }
  };

  // extract data for charts
  const extractData = { year: [], count: [], cost: [] };
  data.forEach(({ year, count, cost }) => {
    extractData.year.push(year);
    extractData.count.push(count);
    extractData.cost.push(cost);
  });
  // set data
  //const maxYLeftAxis = Math.max(...extractData.count);
  //
  // BAR_CHART_CONFIG.yAxis[0].tickPositions = [];
  // for (let i = 0; i < maxYLeftAxis; i += 200) {
  //   BAR_CHART_CONFIG.yAxis[0].tickPositions.push(i);
  // }

  BAR_CHART_CONFIG.xAxis[0].categories = extractData.year;
  BAR_CHART_CONFIG.series[0].data = extractData.count;
  BAR_CHART_CONFIG.series[1].data = extractData.cost;
  BAR_CHART_CONFIG.yAxis[0].max = Math.max(...extractData.count);
  BAR_CHART_CONFIG.yAxis[0].tickAmount = 6;
  BAR_CHART_CONFIG.yAxis[1].max = Math.max(...extractData.cost);
  BAR_CHART_CONFIG.yAxis[1].tickAmount = 6;

  return BAR_CHART_CONFIG;
};
